import { Sex } from '@/customer/models/Customer';
import CustomerProp from '@/customer/models/CustomerProp';
import CustomerRemark from '@/customer/models/CustomerRemark';
import { RemarkGroup } from '@/customer/models/RemarkGroup';

export enum TraceDay {
  // ThreeDays = 3,
  // Week = 7,
  // Month = 30,
  // Quarter = 90,
  // HalfYear = 180,
  // Year = 365,
  All = -1,
}

interface TraceDayItem {
  label: string;
  value: TraceDay;
}

export const TraceDays: TraceDayItem[] = [
  // { label: '最近3天', value: TraceDay.ThreeDays },
  // { label: '最近7天', value: TraceDay.Week },
  // { label: '最近30天', value: TraceDay.Month },
  // { label: '最近90天', value: TraceDay.Quarter },
  // { label: '最近半年', value: TraceDay.HalfYear },
  // { label: '最近1年', value: TraceDay.Year },
  { label: '所有', value: TraceDay.All },
];

export enum SCENE_TYPE {
  Search = 0,
  AcountMigrate = 1,
  ProfileCard = 2,
  QrCode = 3,
  SceneProfileLink = 4,
  SceneProfileItem = 5,
  ScenePaid = 6,
  SceneAd = 7,
  SceneOthers = 8,
}

export interface SceneItem {
  value: string;
  label: string;
}

export const sceneItems: { [index: string]: SceneItem } = {
  Search: {
    value: 'ADD_SCENE_SEARCH',
    label: '公众号搜索',
  },
  AcountMigrate: {
    value: 'ADD_SCENE_ACCOUNT_MIGRATION',
    label: '公众号迁移',
  },
  ProfileCard: {
    value: 'ADD_SCENE_PROFILE_CARD',
    label: '名片分享',
  },
  QrCode: {
    value: 'ADD_SCENE_QR_CODE',
    label: '扫描二维码',
  },
  SceneProfileLink: {
    value: 'ADD_SCENE_PROFILE_LINK',
    label: '图文页内名称点击',
  },
  SceneProfileItem: {
    value: 'ADD_SCENE_PROFILE_ITEM',
    label: '图文页右上角菜单',
  },
  ScenePaid: {
    value: 'ADD_SCENE_PAID',
    label: '支付后关注',
  },
  SceneAd: {
    value: 'ADD_SCENE_WECHAT_ADVERTISEMENT',
    label: '微信广告',
  },
  SceneOthers: {
    value: 'ADD_SCENE_OTHERS',
    label: '其他',
  },
};

interface InteractPeriodItem {
  label: string;
  value: InteractPeriod;
}

export enum InteractPeriod {
  Today = 0,
  TwoDays = 2,
  WeeklyDays = 7,
  MonthlyDays = 30,
  QuarterlyDays = 90,
  HalfYearDays = 160,
  YearDays = 365,
  All = -1,
}

export const InteractPeriods: InteractPeriodItem[] = [
  { label: '今天', value: InteractPeriod.Today },
  { label: '48小时内', value: InteractPeriod.TwoDays },
  { label: '最近7天', value: InteractPeriod.WeeklyDays },
  { label: '最近30天', value: InteractPeriod.MonthlyDays },
  { label: '最近90天', value: InteractPeriod.QuarterlyDays },
  { label: '最近半年', value: InteractPeriod.HalfYearDays },
  { label: '最近1年', value: InteractPeriod.YearDays },
  { label: '所有', value: InteractPeriod.All },
];

export enum FilterCompare {
  Greater = 1,
  Equal = 0,
  Less = -1,
}

export interface TraceFilter {
  compare: FilterCompare;
  count?: number;
}

export interface InteractFilter {
  period: InteractPeriod;
  interactiveType?: number[];
}

export interface MemberFilter {
  notIn: boolean;
  memberIds: number[];
}

export interface SubscribeFilter {
  notIn: boolean;
  periods: string[];
}

export interface GroupFilter {
  notIn: boolean;
  or: boolean;
  groupIds: number[];
}

export interface RemarkFilter {
  notIn: boolean;
  or: boolean;
  remarks: CustomerRemark[];
  remarkGroups?: RemarkGroup[];
}

export interface TopicFilter {
  notIn: boolean;
  topics: number[];
}

export interface AreaFilter {
  notIn: boolean;
  areas: string[][];
}

export interface ScoreFilter {
  minScore: number | null;
  maxScore: number | null;
}

export interface CustomFilter {
  prop?: CustomerProp;
  greater: number;
  notIn: boolean;
  num?: number;
  keywords?: string[];
  date?: string;
  nums?: number[];
}

export interface SubscribeSceneFilter {
  notIn: boolean;
  scenes: string[];
}

export function newCustomFilter(): CustomFilter {
  return {
    prop: undefined,
    notIn: false,
    num: undefined,
    keywords: undefined,
    date: undefined,
    greater: FilterCompare.Greater,
  };
}

export interface CustomerFilter {
  sex?: Sex | -1;
  subscribe: SubscribeFilter;
  subscribeStatus?: boolean;
  area: AreaFilter;
  subscribeScene: SubscribeSceneFilter;
  interact: InteractFilter;
  trace: TraceFilter;
  member: MemberFilter;
  group: GroupFilter;
  remark: RemarkFilter;
  score?: ScoreFilter;
  scoreSum?: ScoreFilter;
  custom: CustomFilter[];
  topics: number[];
  topicQuery: TopicFilter;
}

export const memberFilter: MemberFilter = {
  notIn: false,
  memberIds: [],
};

export const groupFilter: GroupFilter = {
  notIn: false,
  or: true,
  groupIds: [],
};

export const interactFilter: InteractFilter = {
  period: InteractPeriod.All,
};

export const remarkFilter: RemarkFilter = {
  notIn: false,
  or: true,
  remarks: [],
};

export const traceFilter: TraceFilter = {
  compare: FilterCompare.Greater,
  count: 0,
};

export const scoreFilter: ScoreFilter = {
  minScore: null,
  maxScore: null,
};

export const areaFilter: AreaFilter = {
  notIn: false,
  areas: [[]],
};

export const subscribeFilter: SubscribeFilter = {
  notIn: false,
  periods: [],
};

export const subscribeSceneFilter: SubscribeSceneFilter = {
  notIn: false,
  scenes: [],
};

export const topicFilter: TopicFilter = {
  notIn: false,
  topics: [],
};

function copyFilter(filter: any) {
  return JSON.parse(JSON.stringify(filter));
}

const topics: number[] = [];
const customFilter: CustomFilter[] = [];

export function resetCustomerFilter() {
  return {
    sex: -1,
    subscribeStatus: true,
    subscribe: copyFilter(subscribeFilter),
    area: copyFilter(areaFilter),
    interact: copyFilter(interactFilter),
    trace: copyFilter(traceFilter),
    member: copyFilter(memberFilter),
    group: copyFilter(groupFilter),
    remark: copyFilter(remarkFilter),
    score: copyFilter(scoreFilter),
    subscribeScene: copyFilter(subscribeSceneFilter),
    topicQuery: copyFilter(topicFilter),
    custom: copyFilter(customFilter),
    topics,
  };
}

const customerFilter: CustomerFilter = resetCustomerFilter();

export default customerFilter;
